import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { RootState } from 'store';

interface Props {
  children: React.ReactNode;
}
const AuthRoute = ({ children }: Props) => {
  const navigate = useNavigate();
  // In cookie mode, check for user data instead of token
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = token || user;

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <>{children}</>;
};

export default AuthRoute;
